var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.156 98.4204C166.304 56.3559 140.43 14.0299 98.365 3.88263C56.3005 -6.2646 13.9745 19.6095 3.8273 61.674C-6.31994 103.738 19.5541 146.064 61.6186 156.212C103.683 166.359 146.009 140.485 156.156 98.4204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 160C35.9588 160 0 124.206 0 80C0 35.9588 35.9588 0 80 0C124.206 0 160 35.9588 160 80C160 124.206 124.206 160 80 160ZM80 3.29897C37.7732 3.29897 3.29897 37.7732 3.29897 80C3.29897 122.227 37.7732 156.701 80 156.701C122.392 156.701 156.701 122.392 156.701 80C156.701 37.6082 122.392 3.29897 80 3.29897Z",
    fill: "#2BB76B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.227 38.0004L63.2887 91.9386L41.8454 70.4953L27 85.5056L63.2887 121.629L132.072 52.8458L117.227 38.0004Z",
    fill: "#2BB76B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4170a0c1362cc1934d8e05d12772fcfe.svg";
export { ForwardRef as ReactComponent };